var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1987_20648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9365 18C12.3555 18 11.7794 17.8973 11.216 17.6926C8.73416 16.791 6.43047 15.3226 4.5539 13.4461C2.67734 11.5696 1.20892 9.26582 0.307378 6.78396C0.0176675 5.98637 -0.067829 5.16305 0.0533496 4.33677C0.166865 3.5628 0.466665 2.81144 0.920373 2.16388C1.37608 1.51348 1.98363 0.972523 2.6773 0.599495C3.41703 0.201718 4.22443 0 5.07715 0C5.34236 0 5.57156 0.185301 5.62714 0.444603L6.51002 4.56471C6.54999 4.75128 6.49266 4.9454 6.35777 5.08033L4.84917 6.58889C6.27231 9.41836 8.58155 11.7276 11.411 13.1507L12.9196 11.6421C13.0545 11.5073 13.2487 11.45 13.4352 11.4899L17.5553 12.3728C17.8146 12.4283 17.9999 12.6576 17.9999 12.9228C17.9999 13.7755 17.7982 14.5829 17.4004 15.3226C17.0274 16.0163 16.4864 16.6239 15.836 17.0796C15.1885 17.5333 14.4371 17.8331 13.6631 17.9466C13.4206 17.9822 13.1781 18 12.9365 18ZM4.62773 1.14956C3.50295 1.27373 2.50462 1.86328 1.84167 2.80947C1.09618 3.87343 0.922341 5.18206 1.36473 6.3999C3.098 11.1713 6.82867 14.902 11.6001 16.6353C12.8179 17.0776 14.1265 16.9038 15.1905 16.1583C16.1367 15.4954 16.7263 14.497 16.8504 13.3723L13.4987 12.654L11.9232 14.2295C11.7556 14.3972 11.5008 14.4417 11.2863 14.3409C7.93994 12.7688 5.2312 10.06 3.65907 6.71365C3.55828 6.4991 3.60279 6.24437 3.77044 6.07675L5.34594 4.50126L4.62773 1.14956Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1987_20648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f23a3486a09b2b636c9a346c37da5770.svg";
export { ForwardRef as ReactComponent };